function getESTDateTime() {
  return new Date().toLocaleString('en-us', { timeZone: 'America/New_York' });
}

function isDateTimeExpired(dateTime = null) {
  if (dateTime === null) return true;
  const currentDateTime = Date.parse(getESTDateTime());
  const valueOfDateTime = Date.parse(new Date(dateTime).toLocaleString('en-us', { timeZone: 'America/New_York' }));
  return (valueOfDateTime - currentDateTime) < 0;
}

export {
  getESTDateTime,
  isDateTimeExpired,
};
